import type { CookieStyles } from "@/types/cookie-banner/styles";

import { useEffect, useInsertionEffect, useLayoutEffect } from "react";

import { serializeCookieStyles } from "@/functions/serialize-cookie-styles";

const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

export function useCookieStyles(activeTheme: "dark" | "light" = "light", styles?: CookieStyles) {
  useInsertionEffect(() => {
    if (!styles) return;

    const style = document.createElement("style");
    style.innerHTML = serializeCookieStyles(styles);
    document.head.insertAdjacentHTML("beforeend", style.outerHTML);
  }, [styles]);

  useIsomorphicLayoutEffect(() => {
    if (!activeTheme) return;

    const variants = { dark: "cc--darkmode", light: "default-light" };
    const classes = document.documentElement.classList;
    const theme = variants[activeTheme];

    classes.toggle(theme, true);
  }, [activeTheme]);
}
